import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { AccessRightDomainStore } from '../stores/access-right.store';

@Injectable({
  providedIn: 'root',
})
export class AccessRightResolver implements Resolve<void> {
  private readonly accessRightStore = inject(AccessRightDomainStore);

  async resolve(route: ActivatedRouteSnapshot): Promise<void> {
    const id = Number(route.paramMap.get('id'));
    await this.accessRightStore.loadByAssetId(id);

    return Promise.resolve();
  }
}
